import type {
  Metrics,
  QualityResult,
  ScannerConfig,
  ScannerState,
  Step,
} from "../interfaces/types";
import { ALIGN_HINTS, QUALITY_REASONS } from "./messages";

export const evaluateQuality = (
  metrics: Metrics,
  config: ScannerConfig,
  step: Step,
): QualityResult => {
  const q = config.quality;
  const documentDetected =
    metrics.quadAreaRatio != null &&
    metrics.aspectRatio != null &&
    metrics.quadAreaRatio >= q.minDetectAreaRatio;

  if (!documentDetected) {
    return {
      documentDetected: false,
      checks: { framing: false, sharpness: false, brightness: false, glare: false },
      allPass: false,
      reasons: [QUALITY_REASONS.NO_DOCUMENT],
    };
  }

  const reasons: string[] = [];

  const framing =
    metrics.quadAreaRatio! >= q.minQuadAreaRatio &&
    Math.abs(metrics.aspectRatio! - config.guideAspectRatio) <=
      q.aspectRatioTolerance;
  if (!framing) {
    reasons.push(step === "BACK" ? ALIGN_HINTS.BACK : ALIGN_HINTS.FRONT);
  }

  const sharpness = metrics.sharpnessVariance >= q.sharpnessMinVariance;
  if (!sharpness) reasons.push(QUALITY_REASONS.SHARPNESS);

  const brightness =
    metrics.brightness >= q.brightnessMin &&
    metrics.brightness <= q.brightnessMax;
  if (!brightness) {
    reasons.push(
      metrics.brightness < q.brightnessMin
        ? QUALITY_REASONS.LOW_LIGHT
        : QUALITY_REASONS.TOO_MUCH_LIGHT,
    );
  }

  const glare = metrics.glareRatio <= q.glareMaxRatio;
  if (!glare) reasons.push(QUALITY_REASONS.GLARE);

  const allPass = framing && sharpness && brightness && glare;

  return {
    documentDetected: true,
    checks: { framing, sharpness, brightness, glare },
    allPass,
    reasons,
  };
};

export const decideState = (
  qualityResult: QualityResult,
  okScore: number,
  config: ScannerConfig,
): ScannerState => {
  if (!qualityResult.documentDetected) return "ERROR";
  if (okScore >= config.stableFramesToGreen) return "SUCCESS";
  return "PENDING";
};
